import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModeratorService } from 'src/app/shared/moderator/moderator.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-assign-expert',
    templateUrl: './assign-expert.component.html',
    styleUrls: ['./assign-expert.component.css'],
    standalone: false
})
export class AssignExpertComponent implements OnInit {
  showAssignedExperts: Boolean[] = [];
  showNotAssignedExperts: Boolean[] = [];
  assignedTickets: []
  notAssignedTickets: []
  closedTickets
  // userDetails
  role
  custid;
  experts: []
  serverErrorMessages: string;
  closeResult
  ticketToBeAssigned
  randomExpert
  messages: any[] = [];
  ticketID
  constructor(private loginService: LoginService, private moderatorService: ModeratorService, private router : Router, private modalService: NgbModal, private datePipe: DatePipe) {
    this.getAllExperts()
    this.getUnverifiedMessages();
   }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllTickets();
          //this.getClosedTickets();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllTickets(){
    this.moderatorService.getAllTickets().subscribe(
      res => {
        this.assignedTickets = res['ticketAssigned'];
        this.assignedTickets.forEach(a => { this.showAssignedExperts.push(false) })
        this.notAssignedTickets = res['ticketNotAssigned']
        console.log(this.notAssignedTickets)
       //console.log('Got tickets', res);
      },
      err => {
       //console.log('Error getting tickets')
      }
    )
  }

 /* getClosedTickets(){
   //console.log('getting closed tickets')
    this.moderatorService.getClosedTickets().subscribe(
      res => {
        this.closedTickets = res;
      this.custid=(JSON.stringify(res[0]));
        alert("id "+this.custid)
        console.log(JSON.stringify(res))


        console.log('Got closed tickets', res);
      },
      err => {
       //console.log('Error getting closed tickets')
      }
    )
  }*/

  getAllExperts(){
    this.moderatorService.getAllExperts().subscribe(
      res => {
        // this.showAssignedExperts[i] =  !this.showAssignedExperts[i];
        this.experts = res['techExperts']
       //console.log('Got Experts', this.experts)
      },
      err => {
        this.serverErrorMessages = err.erros.message
       //console.log('error getting experts', err)
      }
    )
  }

  closeTicket(i){
   //console.log(i);
    this.moderatorService.closeTicket({ticketID: i}).subscribe(
      res => {
      window.location.reload()
      },
      err => {
        this.serverErrorMessages = err.erros.message
       //console.log('error closing ticket', err)
      }
    )
  }

  assignExpert(expert){


   
   
    // assign expert randomly
  //  console.log(this.experts, this.experts.length);

  //  let count = experts.length;
  //  this.ticketToBeAssigned = ticket
  //  var random = Math.floor(Math.random() * count);

  // //  console.log(random);
   
  //  this.randomExpert = experts[random];
   

  //  if(this.randomExpert)
  //  {  
  //      this.moderatorService.assignExpert({ticketId:this.ticketToBeAssigned._id, techExpertId: this.randomExpert._id }).subscribe(
  //     res => {
  //      console.log('Assigned Ticket', res);
  //       window.location.reload();
  //     },
  //     err => {
  //      //console.log('error assigning ticket', err)
  //       this.serverErrorMessages = err.error.message
  //     }
  //   )
  //  }
  //  else{
  //    console.log("try again!")
  //  }



  this.moderatorService.assignExpert({ticketId:this.ticketToBeAssigned._id, techExpertId: expert._id }).subscribe(
        res => {
        //  console.log('Assigned Ticket', res);
          window.location.reload();
        },
        err => {
         //console.log('error assigning ticket', err)
          this.serverErrorMessages = err.error.message
    })
   
  
  }

  getUnverifiedMessages(){
    this.moderatorService.getAllUnverifiedMessages().subscribe(
      res => {
       //console.log('got all unverified messages', res);
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

  open(content, ticket) {
    this.ticketToBeAssigned = ticket
   //console.log('got ticket to be assigned', this.ticketToBeAssigned)
    this.modalService.open(content,
      {ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static'}).result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
         //console.log(this.closeResult)
      },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         //console.log(this.closeResult)
      }
    );
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  openChat(content, messages, ticketID) {
    ////console.log(content, typeof(content))
    this.messages = messages;
    this.ticketID = ticketID;
   //console.log(messages)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {

      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }
}
